module.exports = __webpack_public_path__ + "img/silver.1d962be5.svg";